import React, { useState, createContext } from 'react';

// Create a Context for the layout state
export const LayoutContext = createContext({});

// The LayoutProvider component
export const LayoutProvider = ({ children }) => {
    // Initial state for layout configuration
    const [layoutConfig, setLayoutConfig] = useState({
        ripple: false,
        inputStyle: 'outlined',
        menuMode: 'overlay',
        colorScheme: 'light',
        theme: 'lara-light-indigo',
        scale: 14,
        overlayZIndex: 1000
    });

    // Initial state for layout state
    const [layoutState, setLayoutState] = useState({
        staticMenuDesktopInactive: false,
        overlayMenuActive: false,
        profileSidebarVisible: false,
        configSidebarVisible: false,
        staticMenuMobileActive: false,
        menuHoverActive: false
    });

    // Toggle the menu based on the current menu mode and screen size
    const onMenuToggle = () => {
        if (isOverlay()) {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                overlayMenuActive: !prevLayoutState.overlayMenuActive
            }));
        }
    
        if (isDesktop()) {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                staticMenuDesktopInactive: !prevLayoutState.staticMenuDesktopInactive
            }));
        } else {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                staticMenuMobileActive: !prevLayoutState.staticMenuMobileActive
            }));
        }
    };
    

    // Show or hide the profile sidebar
    const showProfileSidebar = () => {
        setLayoutState((prevLayoutState) => ({
            ...prevLayoutState,
            profileSidebarVisible: !prevLayoutState.profileSidebarVisible
        }));
    };

    // Check if the menu mode is 'overlay'
    const isOverlay = () => {
        return layoutConfig.menuMode === 'overlay';
    };

    // Check if the screen size is greater than 991px
    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    // Context value to be provided to consumers
    const value = {
        layoutConfig,
        setLayoutConfig,
        layoutState,
        setLayoutState,
        onMenuToggle,
        showProfileSidebar
    };

    return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};
